// extracted by mini-css-extract-plugin
export default {"ipad-images":"manageaccount_ipad-images__BERh0"};